import _Object$keys from 'babel-runtime/core-js/object/keys';
/* eslint-disable prefer-template */
export default function objectToGetParams(object) {
  return '?' + _Object$keys(object).filter(function (key) {
    return !!object[key];
  }).map(function (key) {
    return key + '=' + encodeURIComponent(object[key]);
  }).join('&');
}
/* eslint-enable prefer-template */


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-share/es/utils/objectToGetParams.js
// module id = K0RQ
// module chunks = 11